// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IEnvelopeResendLatestRequest {
    static getAttributeTypeMap() {
        return IEnvelopeResendLatestRequest.attributeTypeMap;
    }
}
IEnvelopeResendLatestRequest.discriminator = undefined;
IEnvelopeResendLatestRequest.additionalProperties = false;
IEnvelopeResendLatestRequest.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
];
//# sourceMappingURL=iEnvelopeResendLatestRequest.js.map